/**
 * Body accessories registry index
 */
import { vietnamese_bags_acc_builders } from './vietnamese-bags.js';
import { vietnamese_misc_acc_builders } from './vietnamese-misc.js';
import { scifi_acc_builders } from './scifi.js';

export const BODY_ACCESSORIES_REGISTRY = {
  ...vietnamese_bags_acc_builders,
  ...vietnamese_misc_acc_builders,
  ...scifi_acc_builders
};
